"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cborNumber = exports.canBeInteger = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
function canBeInteger(something) {
    return ((typeof something === "bigint") ||
        (typeof something === "number" && something === Math.round(something)));
}
exports.canBeInteger = canBeInteger;
function cborNumber(n) {
    if (!canBeInteger(n))
        throw new Error("expected number");
    return n < 0 ? new cbor_1.CborNegInt(n) : new cbor_1.CborUInt(n);
}
exports.cborNumber = cborNumber;
